import * as React from 'react';

import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { LinkContainerStyles, LinkStyles } from './styles';
import { useLogNavigationClick } from './use-log-navigation-click';

export const StyledNoArrowLinkContainer = styled.div`
  ${LinkContainerStyles}
  display: block;
`;

const StyledLink = styled(Link)`
  ${LinkStyles}
`;
const StyledAnchor = styled.a`
  ${LinkStyles}
`;

export const NoArrowLink: React.FC<React.ComponentProps<
  typeof StyledLink | typeof StyledAnchor
>> = ({ children, eventName, onClick, ...props }) => {
  const handleClick = useLogNavigationClick(eventName, onClick);

  return (
    <StyledLink {...props} onClick={handleClick}>
      {children}
    </StyledLink>
  );
};
